import React from "react";
import "./Privacypolicy.css"; // New CSS similar to DisclaimerPopup.css
import MainNavbar from "../MainNavbar";

const PrivacyPolicy = () => {
  return (
    <>
      <MainNavbar />
      <div className="pp-container">
        <header className="pp-header">
          <h1>Privacy Policy</h1>
        </header>

        <section className="pp-content">
          <p>
            At <strong>Varankal Matrimony</strong>, your privacy is very important to us.
            This policy explains how we collect, use, and protect your personal information.
          </p>

          <div className="pp-subpoints">
            <p>
              a. <strong>Information We Collect:</strong> We collect information you provide
              during registration such as name, age, gender, contact details, education,
              profession, photographs, and partner preferences.
            </p>

            <p>
              b. <strong>How We Use Your Information:</strong> Your data is used to create your
              profile, suggest suitable matches, improve our services, and communicate important updates.
            </p>

            <p>
              c. <strong>Data Security:</strong> We use secure servers, encryption, and restricted
              access to protect your personal information from unauthorized use.
            </p>

            <p>
              d. <strong>Profile Visibility:</strong> Your profile is visible only to registered
              users based on your privacy settings. We never sell or rent your personal data.
            </p>

            <p>
              e. <strong>Cookies:</strong> We use cookies to enhance user experience, analyze traffic,
              and personalize content. You can disable cookies in your browser settings.
            </p>

            <p>
              f. <strong>Contact & Communication:</strong> We may contact you via email or SMS for
              account updates, security alerts, and match suggestions.
            </p>

            <p>
              g. <strong>Account Control:</strong> You can edit, hide, or delete your profile at any
              time from your account settings. Once deleted, your data will be permanently removed
              from active systems in accordance with applicable laws.
            </p>

            <p>
              h. <strong>Age Restriction:</strong> Varankal Matrimony services are strictly intended
              for individuals aged 18 years and above. Any account found violating this rule will
              be removed immediately.
            </p>

            <p>
              i. <strong>Policy Updates:</strong> We may update this Privacy Policy periodically
              to reflect legal, technical, or business changes. Continued usage of the platform
              implies acceptance of the updated policy.
            </p>
            <p>
              j. <strong>Child Safety Standards:</strong> Varankal Matrimony is committed to maintaining a safe platform and has a zero-tolerance policy toward any form of Child Sexual Abuse and Exploitation (CSAE).
            </p>

            <p>
              We strictly prohibit:
              <br />• Any content that depicts or promotes sexual abuse of minors
              <br />• Any attempt to contact, exploit, or harm minors
              <br />• Sharing, uploading, or distributing child sexual abuse material
              <br />• Grooming behavior or inappropriate interaction involving minors
            </p>

            <p>
              If we become aware of such activity, we will:
              <br />• Immediately remove the offending content
              <br />• Permanently ban the responsible accounts
              <br />• Report the activity to relevant law enforcement authorities and child protection organizations
            </p>

            <p>
              Users can report suspicious or abusive behavior through our in-app reporting system or by contacting us at
              <br />
              Email: varankalmatrimony@gmail.com
            </p>

            <p>
              We actively monitor reports and cooperate with law enforcement and child protection authorities as required by applicable laws.
            </p>

            <p>
              This policy applies to all users of <strong>Varankal Matrimony</strong>, operated by <strong>Varankal Team</strong>.
            </p>

            <p>
              k. <strong>Contact Us:</strong> For any privacy concerns, you can reach us at:
              <br />
              Phone: +91 98765 43210
              <br />
              Email: varankalmatrimony@gmail.com
              <br />
              Address: Chennai, Tamil Nadu
            </p>


          </div>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;
